import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Button from 'components/Button';
import SVG from 'components/SVG';

import createNewCashbackSVG from '../../../../data/img/create-new-cashback.svg';

import './CashbackHeader.scss';

const b = block('cashback-header-desktop');

const CashbackHeader = ({ onCreateClick }) => {
  const locale = useSelector(s => s.locale.locale);

  return (
    <div className={b()}>
      <h2 className={b('title')}>{locale.cashbackCreation}</h2>

      <div className={b('actions')}>
        <div className={b('button')}>
          <Button callBack={onCreateClick}>
            <div className={b('create-new-cashback-container')}>
              <SVG svgProps={{ svg: createNewCashbackSVG }} className={b('create-new-cashback-icon')} />
              {locale.createNewCashback}
            </div>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CashbackHeader;
